import { Component, OnInit } from '@angular/core';
import { OpenData } from '../../Models/open-data';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenDataService } from '../../services/open-data.service';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { downloadFileUtil } from '../../../../shared/utils/file-downloader';

@Component({
  selector: 'get-open-data-details',
  templateUrl: './get-open-data-details.component.html',
  styleUrls: ['./get-open-data-details.component.scss']
})
export class GetOpenDataDetailsComponent implements OnInit {
 model = {} as OpenData;
  constructor(private route: Router,
      private diag: NbDialogRef<GetOpenDataDetailsComponent>,
      public sanitizer: DomSanitizer,
      private service: OpenDataService) { }

 ngOnInit() {
       this.route.events.subscribe(()=>{
       this.diag.close('false');
      });
   }
   getLabelData(text) {
     return this.sanitizer.bypassSecurityTrustHtml(text);
   }
 
   close() {
     this.diag.close();
   }
 
   downloadFile(fileName) {
     this.service.downloadFile(fileName).subscribe((blob) => {
           downloadFileUtil(blob, fileName);
         });
   }
 

}


